<template>
  <div>
    <header>
      <Header />
    </header>
    <div>
      <div v-if="isDemo()" class="commingSoon">
        <div class="commingSoonMessage">
          Coming Soon
        </div>
      </div><!-- /main-->
      
      <div v-else>
      
        <div class="exhMessage">
          <div class="exhAbout">
            <div class="aboutJp">
              <h2>開催概要</h2>
              <p class="exhDate">開催期間</p>
              <div class="exhDate">
                <div class="table">
                  <div class="row">
                    <div class="header">in Hikarie</div><div>2022/9/16（金）～2022/9/19（月）</div>
                  </div>
                  <div class="row">
                    <div class="header">Online</div><div>2022/9/16（金）～2022/10/22（土）</div>
                  </div>
                </div>
              </div>

              <p class="mainTxt">
                2021年に東京カメラ部とその分室で11億人*1を超える人々が約4,250万作品*2の中から選んだ作品「10選2021」を中心に新作、自信作を追加。更に2012年、2013年、2014年、2015年、2016年、2017年、2018年、2019年、2020年に選ばれた10選メンバーを加えた、10選10世代による合同展示です。<br>
                <br>
                本展示の開催は今年で10回目となります。過去7回目までは、都内にて大規模展示を開催し日本全国から大勢の方にお越しいただいてきましたが、8回目、9回目は新型コロナウイルス感染症（COVID-19）対策としてオンラインでの開催とさせていただきました。まだまだ厳しい状況は続いていますが、複数回のワクチン接種も進んだことなどを踏まえて、今年は、オンラインに加えて感染防止対策を実施した上でオフラインでの開催*3を予定しています。<br>
              </p>
              <p class="attention">
                *1 11億人:東京カメラ部とその分室がタイムラインで紹介している作品の2021年延べリーチ（閲覧者）数（Facebook、Instagram、Twitter、Weiboインサイト）に基づく<br>
                *2 約4,250万作品：2020年末迄に東京カメラ部とその分室に投稿いただいた総作品数<br>
                *3「東京カメラ部2022写真展」はリアル写真展（オフライン）の開催も準備をすすめていますが、天変地異、感染症予防、政府および官公庁による規制など、やむをえない事情によりオンラインのみとする場合や、オフライン開催決定後も急遽中止とさせていただく可能性がございます。
              </p>
              <p class="mainTxt">
                また、新型コロナウイルス感染症（COVID-19）の影響により甚大な被害を受けた日本全国の名勝地、観光業の支援の要素をより強くするため日本全国名勝地の四季写真を募集したフォトコンテスト「日本写真100景＜四季＞2022」の入選作品、東京カメラ部写真展会場ではトップクラスの人気を誇っていましたが、他の展示との関係などで2019年を最後に2年連続で開催できず今年ついに復活した「東京カメラ部2022写真コンテスト Instagram部門（３×３）」の入選作品、多様な文化視点で捉えた日本の写真を募集した「Japan Travel Gallery Photo Contest」の入選作品、東京カメラ部Weiboアカウントにて開催した“私と写真撮影との物語”がテーマのフォトコンテスト入選作品と東京カメラ部Weiboアカウントへのご投稿作品から選ばれた作品、“おすすめのご当地グルメ”をテーマにしたTwitterフォトコンテストの入選作品、さらには日本写真100景の応募作品より各地の「城と月」の素晴らしい作品を集めた「城と月」特別部門展示も加え、約733作品を展示します。<br>
                <br>
                オフライン展示は、2019年の写真と同じ会場である約1,400㎡（約420坪）と都心最大級の広さを誇る渋谷ヒカリエ9階「ヒカリエホール ホールA」にて行います。渋谷ヒカリエは、JR山手線、東急東横線・田園都市線などから通路、出口直結。利便性の極めて高い場所です。新型コロナウィルス対策を徹底のうえ、ぜひお越しくださいませ。<br>
                <br>
                みなさまのご来場を心よりお待ち申し上げます。<br>
                <br>
                オンライン展示は、オンラインですべての作品をご覧いただくことや出展者へのコメントを通じた出展者の方との交流が可能となっています。時間、場所を気にせず、ゆっくりとお楽しみいただけますと幸いです。<br>
              </p>

            </div><!-- /aboutJp-->

         </div><!-- /exhAbout-->

        </div><!-- /exhMessage-->











      </div>
    </div>
    <Footer />
    <div class="actionMenu">
      <UpButton />
    </div>

    <YoutubeDialog :isOpen.sync="videoDialog1" url="https://www.youtube.com/embed/0C5hY9do9gw"></YoutubeDialog>
    <YoutubeDialog :isOpen.sync="videoDialog2" url="https://www.youtube.com/embed/uTq6DIIPsc8"></YoutubeDialog>
    <YoutubeDialog :isOpen.sync="videoDialog3" url="https://www.youtube.com/embed/z7S7__SDgmc"></YoutubeDialog>
    <YoutubeDialog :isOpen.sync="videoDialog4" url="https://www.youtube.com/embed/lDa-mjTHG0k"></YoutubeDialog>
  </div>
</template>

<script>
import { mapGetters } from 'vuex'
import Header from '@/components/modules/Header.vue'
import Footer from '@/components/modules/Footer.vue'
import enumMixin from '@/concern/enumMixin'
import constMixin from '@/concern/constMixin'
import UpButton from '@/components/modules/UpButton.vue'
import YoutubeDialog from '@/components/modules/YoutubeDialog.vue'

export default {
  mixins: [enumMixin, constMixin], // Enum値, const値の読み込み
  components: {
    Header,
    Footer,
    UpButton,
    YoutubeDialog
  },
  data () {
    return {
      lang: 'ja',
      videoDialog1: false,
      videoDialog2: false,
      videoDialog3: false,
      videoDialog4: false,
    }
  },
  computed: {
    ...mapGetters(['winners', 'winnersByAwardType', 'areas'])
  },
  methods: {
    isDemo () {
      return process.env.VUE_APP_DEMO_HOST ? (location.host.indexOf(process.env.VUE_APP_DEMO_HOST) >= 0) : false
    },
    setTitleAndDescription (to) {
      document.title = to.meta.title ? to.meta.title : ''
      document
        .querySelector('meta[name="description"]')
        .setAttribute('content', to.meta.desc ? to.meta.desc : '')
    },
    openVideoDialog (e) {
      const id = e.currentTarget.getAttribute('data-id')
      this.videoDialog1 = (id === "0")
      this.videoDialog2 = (id === "1")
      this.videoDialog3 = (id === "2")
      this.videoDialog4 = (id === "3")

      this.$ga.event('YouTube', 'open', id, null)
    }
  },
  created () {},
  mounted () {
    // titleとdescriptionの設定
    this.setTitleAndDescription(this.$route)
  },
  watch: {
    $route: function (to) {
      this.setTitleAndDescription(to)
    }
  }
}
</script>

<style scoped>
.commingSoon {
  height: 600px;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
}

.commingSoonMessage {
  margin-top: -24px;
  text-align: center;
  font-size: 3rem;
  width: 600px;
}
</style>
